$('iframe').each(function(i, obj) {
    var attr = $(this).attr('title');

    if (typeof attr !== typeof undefined && attr !== false) {
    } else{
        $(this).prop('title', 'Iframe for video #' + i);
    }
});